// import Swiper JS
import Swiper, { Navigation } from 'swiper';
// import Swiper styles
import 'swiper/css';

function initSwiper() {
  return new Swiper( '.swiper', {
    direction: 'horizontal',
    modules: [Navigation],
    slidesPerView: 1.1,
    spaceBetween: 32,
    cssMode: false,
    loop: false,
    centeredSlides: true,
    centeredSlidesBounds: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        centeredSlides: false,
      },
      990: {
        // enabled: false,
        slidesPerView: 3,
      }
    }
  } );
}

export default {
  init() {
    initSwiper();
  },
};